export default class MessageCenterStyle {
    static messageItem(theme = {}) {
        return ({
            bodyConversation: {
                display: 'flex',
                width: '100%',
            },
            listItem: {
                backgroundColor: theme.palette.background.secondary,
                marginBottom: theme.spacing(3),
                borderRadius: theme.spacing(1),
                padding: theme.spacing(3, 1.5),
                '&:last-child': {
                    marginBottom: 0,
                },
                flexDirection: 'column',
                border: '2px solid transparent',
            },
            customerDetails: {
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                overflow: 'hidden',
            },
            customerName: {
                color: theme.palette.text.grayLabel,
                textTransform: 'capitalize',
            },
            nameLastConnection: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            },
            cellPhone: {
                fontSize: '13px',
            },
            conversationSelected: {
                border: `2px solid rgb(${theme.palette.rgb.purple}, 0.5)`,
            },
            avatar: {
                backgroundColor: '#9668D3',
            },
            boldText: {
                fontWeight: 'bold',
                color: theme.palette.text.purpure,
            },
            newMessage: {
                width: 8,
                height: 8,
                display: 'flex',
                borderRadius: '50%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgb(24, 144, 255)',
            },
            lotname: {
                fontSize: '13px',
                position: 'absolute',
                bottom: '10px',
                right: '15px',
                padding: '2px 4px',
                background: '#dfdff6',
                borderRadius: '3px',
                color: '#777294',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: '400',
            },
        });
    }
}
